module.exports = __webpack_public_path__ + "img/room.986287ac.png";